import React from 'react'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LoyaltyTierPill from 'components/Luxkit/LoyaltyTierPill'
import TextLink from 'components/Luxkit/TextLink'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import TriplePointTakeoverLogo from './TriplePointTakeoverLogo'
import BodyText from 'components/Luxkit/Typography/BodyText'

function TriplePointTakeoverSearchBanner() {
  const [tier] = useCurrentLoyaltyTier()
  return <Group direction="horizontal" gap={20} verticalAlign="center">
    <TriplePointTakeoverLogo size="medium" />
    <VerticalSpacer gap={2}>
      <Heading variant="heading3">Your next trip just got 3x better</Heading>
      <BodyText variant="large">
        <Group direction="horizontal" gap={4} verticalAlign="center">
          Look for <LoyaltyTierPill variant="primary" tier={tier}>Triple Points</LoyaltyTierPill>{' '}
          on select packages! Valid until 12 July 2025. <TextLink to="/triple-points">View all offers</TextLink>
        </Group>
      </BodyText>
    </VerticalSpacer>
  </Group>
}

export default TriplePointTakeoverSearchBanner
